module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav_left"
  }, [_vm._m(0), _vm._v(" "), _c('el-scrollbar', {
    attrs: {
      "wrapClass": "scrollbar-wrapper"
    }
  }, [_c('el-menu', {
    attrs: {
      "mode": "vertical",
      "show-timeout": 200,
      "default-active": _vm.$route.path,
      "collapse": _vm.isCollapse,
      "background-color": "#304156",
      "text-color": "#bfcbd9",
      "active-text-color": "#409EFF",
      "router": ""
    }
  }, _vm._l((_vm.routes), function(route) {
    return _c('sidebar-item', {
      key: route.name,
      attrs: {
        "menu": route,
        "router": "",
        "base-path": route.path
      }
    })
  }))], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "h5pay"
  }, [_vm._v("h5 pay平台")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-755e6dce","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/Sidebar/index.vue
// module id = NfLg
// module chunks = 3